import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {OfwcaService} from "../../../../shared/services/ofwca.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
  ChangeRegionalDialogData
} from "../../../ofwcas/ofwca-change-account-number-dialog/ofwca-change-account-number-dialog.component";
import {ReplaySubject} from "rxjs";
import {Ofwca} from "../../../../shared/interface/ofwca";
import {validIban} from "../../../../shared/validator/iban-validator";
import {delay, takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {ReceivablesBalanceService} from "../../../../shared/services/receivables-balance.service";

export interface UpdateOfwcaDialogData {
  partnerId: string;
  receivableBalanceId: string;
}

@Component({
  selector: 'app-receivables-balance-update-ofwca',
  templateUrl: './receivables-balance-update-ofwca.component.html',
  styleUrls: ['./receivables-balance-update-ofwca.component.scss']
})
export class ReceivablesBalanceUpdateOfwcaComponent implements OnInit, OnDestroy {


  changeOfwcaForm: FormGroup;
  partnerId: string;
  receivableBalanceId: string;
  processingRequest = false;
  enableSaveButton = false;
  ofwcaControl: FormControl;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  constructor(
    public dialogRef: MatDialogRef<ReceivablesBalanceUpdateOfwcaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UpdateOfwcaDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private receivablesBalanceService: ReceivablesBalanceService,
    private snack: MatSnackBar,
  ) {
    this.partnerId = data.partnerId;
    this.receivableBalanceId = data.receivableBalanceId;
    this.changeOfwcaForm = fb.group({
      ofwca: this.ofwcaControl = fb.control('',
        [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.changeOfwcaForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.changeOfwcaForm.valid);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  sendForm(): void {
    this.processingRequest = true;

    this.receivablesBalanceService.sendUpdateOfwca(this.changeOfwcaForm.value, this.receivableBalanceId)
      .subscribe(() => {
        this.snack.open('Pomyślnie dodano OFWCA', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas aktualizacji salda wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }
}
